// extracted by mini-css-extract-plugin
export default {"center":"Loading_center__0Mi5B"};